import log4js from 'log4js';
import axios, { type AxiosRequestHeaders } from 'axios';
import isLogged from '~/utils/logs-utils/isLogged';

interface ILogMessage {
  type?: string;
  url?: string;
  headers?: AxiosRequestHeaders;
  duration?: number;
  dateTimeRequest?: string;
  config?: { start?: string; url?: string };
  status?: number;
  data?: string;
}

const logGatewayCall = (level: string, message: ILogMessage) => {
  const maxLevel: string = import.meta.env.VITE_LOG_LEVEL || 'error';
  const logged = isLogged(level, maxLevel);
  if (logged) {
    if (import.meta.env.SSR) {
      try {
        const logger = log4js.getLogger();
        // @ts-ignore
        logger[level](JSON.stringify(message));
      } catch {}
    } else {
      try {
        if (navigator.sendBeacon)
          navigator.sendBeacon(
            '/api/logger',
            JSON.stringify({ message, level })
          );
        else axios.post('/api/logger', { message, level });
      } catch {}
    }
  }
};
export const logger = {
  debug: (message: ILogMessage) => logGatewayCall('debug', message),
  info: (message: ILogMessage) => logGatewayCall('info', message),
  warn: (message: ILogMessage) => logGatewayCall('warn', message),
  fatal: (message: ILogMessage) => logGatewayCall('fatal', message),
  error: (message: ILogMessage) => logGatewayCall('error', message),
  off: (message: ILogMessage) => logGatewayCall('off', message),
  trace: (message: ILogMessage) => logGatewayCall('trace', message),
};
export const sendError = (error: ILogMessage) => {
  if (typeof error === 'object') {
    logger.error(JSON.parse(JSON.stringify(error)));
  } else {
    logger.error(error);
  }
};
